import React, { memo } from 'react';
import { getLeafChildrenData } from 'timeSheet/utils';
import { ActionsAggregateRenderer, ActionsRenderer } from 'timeSheet/components/CellRenderers';

const ActionRendererByRowType = memo((params) => {
  const {
    createDailyShift,
    deleteTimeSheet,
    crossAccountUnbookEmployee,
    approveAllTimeSheet,
    setShiftModal,
    autofill,
    refetchTimesheet,
    groupBy,
    hasActionPermission,
    mappedSupplierBranches,
    approveOSTimeSheets,
    autoFillOSTimeSheets,
    amplitudeModuleName
  } = params.colDef?.cellRendererParams || {};

  if (params.node?.group) {
    const subRows = getLeafChildrenData(params.node);

    return (
      <ActionsAggregateRenderer
        mappedSupplierBranches={mappedSupplierBranches}
        refetchTimesheet={refetchTimesheet}
        rowData={{ subRows }}
        columnData={{
          approveAllTimeSheet,
          autofill,
          approveOSTimeSheets,
          autoFillOSTimeSheets,
          groupBy,
          hasActionPermission
        }}
      />
    );
  }

  const rowData = params.data;

  return (
    <ActionsRenderer
      rowData={rowData}
      columnData={{
        onClickShift: setShiftModal,
        createDailyShift,
        deleteTimeSheet,
        crossAccountUnbookEmployee,
        autofill,
        hasActionPermission,
        amplitudeModuleName
      }}
    />
  );
});

export default ActionRendererByRowType;
